import { z } from "zod";
/** Base error response shape shared by all error responses */
export const apiErrorSchema = z.object({
    error: z.string().meta({ description: "HTTP error category", example: "Bad Request" }),
    message: z.string().meta({ description: "English developer-facing message", example: "Validation failed" }),
    error_code: z.string().optional().meta({ description: "Machine-readable error code for frontend translation", example: "bucket_already_started" }),
});
export const badRequestResponseSchema = apiErrorSchema.meta({ description: "Bad Request" });
export const unauthorizedResponseSchema = apiErrorSchema.omit({ error_code: true }).meta({ description: "Unauthorized" });
export const forbiddenResponseSchema = apiErrorSchema.omit({ error_code: true }).meta({ description: "Forbidden" });
export const notFoundResponseSchema = apiErrorSchema.meta({ description: "Not Found" });
export const conflictResponseSchema = apiErrorSchema.meta({ description: "Conflict" });
export const internalServerErrorResponseSchema = apiErrorSchema.meta({ description: "Internal Server Error" });
export const notImplementedResponseSchema = apiErrorSchema.meta({ description: "Not Implemented" });
/** Extended conflict with details array -- for batch operations returning multiple violations */
export const conflictWithDetailsResponseSchema = (detailSchema) => apiErrorSchema.extend({
    details: z.array(detailSchema).meta({ description: "List of individual conflict details" }),
});
